import React from "react";
import DepartmentChips from "./DepartmentChips";
import styles from "./EmployeeList.module.scss";

const EmployeeRow = ({ employee, onEdit, onDelete, onDuplicate }) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardInfo}>{employee.name}</div>
      <div className={styles.cardInfo}>{employee.code}</div>
      <div className={styles.cardInfo}>
        <DepartmentChips departments={employee.department} />
      </div>
      <div
        className={styles.editEmployeeButtton}
        onClick={() => onEdit(employee)}
      >
        Edit
      </div>
      <div
        className={styles.editEmployeeButtton}
        onClick={() => onDuplicate(employee)}
      >
        Duplicate
      </div>
      <div
        className={styles.deleteEmployeeButtton}
        onClick={() => onDelete(employee)}
      >
        Delete
      </div>
    </div>
  );
};

export default EmployeeRow;
